var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-tab',{staticClass:"fix-top"},[[_c('router-link',{staticClass:"tab",attrs:{"tag":"div","to":"fr","replace":""}},[_c('span',[_vm._v("分润记录")])]),_vm._v(" "),_c('router-link',{staticClass:"tab",attrs:{"tag":"div","to":"ds","replace":""}},[_c('span',[_vm._v("打赏记录")])])]],2),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ce7a727","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal/wallet/wallet-mingxi.vue
// module id = null
// module chunks = 